import React, { useMemo } from "react";
import { VisualBannerLayoutProps } from "@companion-core/shared/app/Interfaces/blocks";
import { getCloudinaryOptimizedUrl } from "@companion-core/shared/app/Utils/cloudinary";
import { getResolvedDescriptionAlt } from "@companion-core/shared/app/Utils/componentHelper";
import "@companion-core/web/src/Assets/Styles/scss/blockBanner.scss";

export const VisualBannerLayout = ({
  title,
  backgroundUrl,
  visualUrl,
  visualDescriptionAlt,
}: VisualBannerLayoutProps) => {
  const backgroundImageUrl = useMemo(
    () => (backgroundUrl ? getCloudinaryOptimizedUrl(backgroundUrl, { contentType: "card" }) : ""),
    []
  );
  const visualImageUrl = useMemo(
    () => (visualUrl ? getCloudinaryOptimizedUrl(visualUrl, { contentType: "card" }) : ""),
    []
  );

  return (
    <section
      data-testid="visual-banner-layout"
      className="visual-banner-layout"
      style={
        backgroundUrl
          ? {
              backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url("${backgroundImageUrl}")`,
            }
          : {}
      }>
      <div className="visual-banner-layout__content">
        <img
          data-testid="visual-banner-layout__visual"
          className="visual-banner-layout__visual"
          src={visualImageUrl ?? ""}
          alt={getResolvedDescriptionAlt(visualDescriptionAlt, title)}
        />

        <h1
          data-testid="visual-banner-layout__title"
          className="visual-banner-layout__title super-title-3">
          {title}
        </h1>
      </div>
    </section>
  );
};
